<div
    (mouseenter)="onMouseEnter()"
    (mouseleave)="onMouseLeave()"
    [class.collapsed]="collapsed"
    [class.open]="collapsed && collapsedOpen$ | async"
    class="sidenav flex flex-col"
>
    <div class="sidenav-toolbar flex-none flex items-center "
    [ngClass]="sideNavOpen?'padding-left-30':'padding-left-0'">

        <img [src]="dellLogo" class="w-6 select-none flex-none p-0" />
        <h2 class="title ltr:pl-4 rtl:pr-4 select-none flex-auto">
            {{ title$ | async }}
        </h2>
        <!-- <button style="margin-left: 80px;"
            (click)="toggleCollapse()"
            *ngIf="showCollapsePin$ | async"
            class="w-8 h-8 -mr-2 leading-none flex-none hidden lg:block"
            mat-icon-button
            type="button"
            [attr.aria-label]="collapsed ? 'Show Navigation Labels' : 'Hide Navigation Labels'"
        >
            <mat-icon
                *ngIf="!collapsed"
                [icIcon]="icRadioButtonChecked"
                size="14px"
            ></mat-icon>
            <mat-icon
                *ngIf="collapsed"
                [icIcon]="icRadioButtonUnchecked"
                size="14px"
            ></mat-icon>
        </button> -->

        <button style="margin-left: 80px;"
            (click)="toggleCollapse()"
            *ngIf="showCollapsePin$ | async"
            class="w-8 h-8 -mr-2 leading-none flex-none hidden lg:block"
            mat-icon-button
            type="button"
            [attr.aria-label]="collapsed ? 'Show Navigation Labels' : 'Hide Navigation Labels'">

            <!-- Collapse icon -->
            <svg *ngIf="!collapsed" xmlns="http://www.w3.org/2000/svg"
                class="icon icon-tabler icon-tabler-layout-sidebar-left-collapse"
                width="20" height="20" viewBox="0 0 24 24"
                stroke-width="2" stroke="currentColor" fill="none"
                stroke-linecap="round" stroke-linejoin="round">
                <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                <path d="M4 4v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-16a2 2 0 0 0 -2 -2h-12a2 2 0 0 0 -2 2z" />
                <path d="M9 4v16" />
                <path d="M15 10l-2 2l2 2" />
            </svg>

            <!-- Expand icon -->
            <svg *ngIf="collapsed" xmlns="http://www.w3.org/2000/svg"
                class="icon icon-tabler icon-tabler-layout-sidebar-left-expand"
                width="20" height="20" viewBox="0 0 24 24"
                stroke-width="2" stroke="currentColor" fill="none"
                stroke-linecap="round" stroke-linejoin="round">
                <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                <path d="M4 4v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-16a2 2 0 0 0 -2 -2h-12a2 2 0 0 0 -2 2z" />
                <path d="M9 4v16" />
                <path d="M11 12l2 -2l-2 -2" />
            </svg>

        </button>


    </div>

    <vex-scrollbar class="flex-auto" aria-label="Side navigation">
        <div class="sidenav-items">
            <vex-sidenav-item
                *ngFor="let item of items; trackBy: trackByRoute"
                [item]="item"
                [level]="0"
            ></vex-sidenav-item>
        </div>
    </vex-scrollbar>
</div>
